import cx from "classnames";
import { useShallow } from "zustand/react/shallow";

import { Magnify } from "components/icons/generated";
import useCommandPaletteStore from "components/CommandPalette/store/useCommandPaletteStore";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationShowsExpandedContent } from "components/MainNavigation/selectors/navigationState";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import BaseActionButton from "ds/components/BaseAction/Button";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import { isMacLike } from "utils/navigator";

import styles from "./styles.module.css";

const MainNavigationSearchButton = () => {
  const showsExpandedContent = useMainNavigationStore(selectNavigationShowsExpandedContent);
  const { isModalOpen, setModalOpen } = useCommandPaletteStore(
    useShallow((state) => ({
      isModalOpen: state.isModalOpen,
      setModalOpen: state.setModalOpen,
    }))
  );
  const { transitionClasses } = useMainNavigationFadeTransition(!!showsExpandedContent);

  const shortcut = isMacLike ? "⌘K" : "Ctrl+K";

  const handlePress = () => setModalOpen(true);

  return (
    <BaseActionButton
      aria-label="Search Spacelift"
      className={cx(styles.searchButton, {
        [styles.active]: isModalOpen,
        [styles.collapsed]: !showsExpandedContent,
      })}
      onPress={handlePress}
      justify="start"
      fullWidth
    >
      <Box align="center" gap="medium" grow="1">
        <Icon src={Magnify} color={showsExpandedContent ? "secondary" : "primary"} noShrink />
        <Typography
          variant="p-body3"
          tag="span"
          color="secondary"
          className={cx(styles.placeholder, transitionClasses)}
        >
          {`Search ${shortcut}`}
        </Typography>
      </Box>
    </BaseActionButton>
  );
};

export default MainNavigationSearchButton;
